var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebookIcon = function SvgFacebookIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3447 13.1068L16.863 9.69417H13.621V7.48058C13.621 6.54672 14.0731 5.63592 15.5251 5.63592H17V2.73058C17 2.73058 15.6621 2.5 14.3836 2.5C11.7123 2.5 9.96804 4.13483 9.96804 7.0932V9.69417H7V13.1068H9.96804V21.357C10.5639 21.4516 11.1735 21.5 11.7945 21.5C12.4155 21.5 13.0251 21.4516 13.621 21.357V13.1068H16.3447Z",
    fill: "currentColor"
  })));
};
export default SvgFacebookIcon;